import { TranslateService } from '@ngx-translate/core';
import { PageResponse } from '@models/page-response';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';
import { CommonService } from '@services/common.service';
import { Injectable } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { HttpClient, HttpParams } from '@angular/common/http';
import { OnepageProduct, OnepageProductFormSearchingCriteria, OnepageProductOption } from '@app/models/onepage-product';


@Injectable()
export class ProductService {

    constructor(
        private httpClient: HttpClient,
        private commonService: CommonService,
        private translate: TranslateService
    ) { }

    globalSearch(globalCriteria: string = '', criteria: OnepageProductFormSearchingCriteria, page: number = 0, size: number = 10, sortField: string, sortDirection: string = 'asc'): Observable<PageResponse<OnepageProduct>> {

        let params: HttpParams = new HttpParams();
        params = params.set('global', globalCriteria);
        params = params.set('criteria', JSON.stringify(criteria == null ? new OnepageProductFormSearchingCriteria() : criteria));
        params = params.set('page', page.toString());
        params = params.set('size', size.toString());
        if (sortField != null) {
            params = params.set('sort', sortField + ',' + sortDirection);
        }

        return this.httpClient.get(`${environment.API_END_POINT}/product`, { headers: this.commonService.getHeaders(), params: params })
            .pipe(
                map(response => {
                    let tempObj = <OnepageProduct[]>(<any>response);
                    return tempObj;
                }),
                catchError((error: Response | any) => this.commonService.handleHttpError(error))
            );
    }

    insert(workflowForm: OnepageProduct): Observable<OnepageProduct> {

        let body = JSON.stringify(workflowForm);

        return this.httpClient.post(`${environment.API_END_POINT}/product`, body, { headers: this.commonService.getHeaders() })
            .pipe(
                map(response => {
                    let tempObj = <OnepageProduct>((<any>response).content);
                    return tempObj;
                }),
                catchError((error: Response | any) => this.commonService.handleHttpError(error))
            );
    }

    
    update(emailTemplate: OnepageProduct): Observable<OnepageProduct> {
      
        let body = JSON.stringify(emailTemplate);

        return this.httpClient.put(`${environment.API_END_POINT}/product`, body, { headers: this.commonService.getHeaders() })
            .pipe(
                map(response =>  {
                    let tempObj = <OnepageProduct>((<any>response).content);
                    return tempObj;
                }),
                catchError((error: Response | any) => this.commonService.handleHttpError(error))
            );

    }

    get(id: string): Observable<OnepageProduct> {
        return this.httpClient.get(`${environment.API_END_POINT}/product/${id}`, { headers: this.commonService.getHeaders() })
            .pipe(
                map(response => {
                    let tempObj = <OnepageProduct>((<any>response).content);
                    return tempObj;
                }),
                catchError((error: Response | any) => this.commonService.handleHttpError(error))
            );
    } 

    getProductOptions(): Observable<OnepageProductOption> {
        return this.httpClient.get(`${environment.API_END_POINT}/product/getProductOptions`, { headers: this.commonService.getHeaders() })
            .pipe(
                map(response => {
                    let tempObj = <OnepageProductOption>((<any>response).content);
                    return tempObj;
                }),
                catchError((error: Response | any) => this.commonService.handleHttpError(error))
            );
    } 
}